// extracted by mini-css-extract-plugin
export default {"root":"WazSR","primary":"W9iga"};